export const AGREEMENT_TYPE_PRICE_CHANGE = 1
export const AGREEMENT_TYPE_ASSORTMENT_CHANGE = 2
export const AGREEMENT_TYPE_INCREASE_DELIVERY_VOLUME = 3
export const AGREEMENT_TYPE_EXPIRATION_DATE_CHANGE = 4

export const GetAgreementTypeText = type => {
    switch (type) {
        case AGREEMENT_TYPE_PRICE_CHANGE:
            return "изменение цены товара"
        case AGREEMENT_TYPE_ASSORTMENT_CHANGE:
            return "расширение ассортимента"
        case AGREEMENT_TYPE_INCREASE_DELIVERY_VOLUME:
            return "увеличение объемов поставки"
        case AGREEMENT_TYPE_EXPIRATION_DATE_CHANGE:
            return "продление срока действия договора"

        default:
    }
}